import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';
import { FontWeights } from '@picsart/design-system/foundation/fonts';

const useStyles = createUseStyles(
  () => ({
    root: {
      marginBlock: Spacings.s48,
    },
    description: {
      fontSize: FontSizes.s16,
      fontWeight: FontWeights.medium,
      lineHeight: LineHeights.l24,
    },
    summaryTile: {
      marginBottom: Spacings.s24,
      marginTop: Spacings.s56,
      lineHeight: LineHeights.l48,
    },
  }),
  {
    name: 'summary-content',
  },
);

export default useStyles;
